import { Component, Inject, OnDestroy, OnInit } from '@angular/core'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { Subject, takeUntil } from 'rxjs'

@Component({
    selector: 'app-competitor-pinning-dialog',
    templateUrl: './add-competitor-pinning-dialog.component.html',
    styleUrls: ['./add-competitor-pinning-dialog.component.scss'],
    standalone: false
})
export class AddCompetitorPinningDialog implements OnInit, OnDestroy {
  destroy$ = new Subject()

  addPinningForm: FormGroup
  selectedpinning

  crossData
  pinnings

  skipErrors = false

  focus = {
    pinning: false,
  }

  pinningLFIC = [
    {
      name: 'Corbin ',
      value: 4,
    },
    {
      name: 'Sargent',
      value: 3,
    },
  ]

  public errorMessages = {
    pinning: [{ type: 'required', message: 'Pinning selection is required.' }],
  }

  constructor(
    public form: FormBuilder,
    private dialogRef: MatDialogRef<AddCompetitorPinningDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.crossData = data
    this.addPinningForm = this.form.group({
      pinning: new FormControl('', [Validators.required]),
    })
  }

  /* istanbul ignore next */
  ngOnDestroy(): void {
    this.destroy$.next(true)
    this.destroy$.complete()
  }

  /* istanbul ignore next */
  ngOnInit() {}

  /* istanbul ignore next */
  addPinning() {
    if (this.addPinningForm.valid) {
      const data = this.addPinningForm.controls.pinning.value
      this.dialogRef.close(data)
    }
  }

  /* istanbul ignore next */
  focusOn(focus) {
    this.focus[focus] = !this.focus[focus]
  }

  /* istanbul ignore next */
  fieldHasErrorMessages(form, validation, fieldName) {
    const field = form.get(fieldName)
    return Boolean(field.hasError(validation.type) && (field.dirty || field.touched))
  }

  /* istanbul ignore next */
  fieldHasError(form, fieldName) {
    const field = form.get(fieldName)

    return Boolean(field.invalid && (field.dirty || field.touched))
  }

  /* istanbul ignore next */
  close() {
    this.dialogRef.close()
  }
}
